/**
 * Removes all falsy elements from an array and returns with correct type
 */
export const filterEmpty = <T = unknown>(list: Array<T | 0 | null | undefined>) =>
  list.filter(it => it !== null && it !== undefined) as T[];

/**
 * Move item from old index to new index
 */
export const moveListItemByIndex = <T = unknown>(
  list: Array<T>,
  prevIndex: number,
  newIndex: number,
) => {
  if (list.length === 0) {
    return list;
  }
  const listCopy = [...list];

  // @ts-expect-error fixable: unchecked index access
  listCopy.splice(newIndex, 0, listCopy.splice(prevIndex, 1)[0]);
  return listCopy;
};

/**
 * Distributes a list across `columnCount` columns in round-robin (reading)
 * order: item 0 → column 0, item 1 → column 1, …, wrapping back to column 0.
 *
 * Rendering the returned columns left-to-right preserves the original order
 * when read row by row, while letting each column stack to its own height
 * (avoids the equal-row-height gaps a CSS grid produces with variable-height
 * items). `columnCount` is floored at 1.
 */
export const distributeIntoColumns = <T = unknown>(list: T[], columnCount: number): T[][] => {
  const columns: T[][] = Array.from({ length: Math.max(1, columnCount) }, () => []);
  list.forEach((item, index) => {
    columns[index % columns.length]?.push(item);
  });
  return columns;
};

export const replaceListItemOrAdd = <T = unknown>(
  list: Array<T>,
  item: T,
  predicate: (value: T) => boolean,
) => {
  const patchedItemIndex = list.findIndex(predicate);

  if (patchedItemIndex > -1) {
    const listCopy = [...list];
    listCopy[patchedItemIndex] = item;
    return listCopy;
  }

  return [...list, item];
};
